import { v4 as uuidv4 } from 'uuid';

export const defaultTargetID = { id: '', type: '' };
export const defaultKpiSettingsPopupData = {
  isPopup: false,
  isNew: true,
  kpiSchema: { chartID: uuidv4() },
};
